import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Registration from '../components/Registration.vue'
import Stores from '../components/Stores.vue'
import History from '../components/History.vue'
import Info from '../components/Info.vue'
import InfoStored from '../components/Info-Stored.vue'
import Results from '../components/Results.vue'
import Gift from '../components/Gift.vue'
import Terms from '../components/Terms.vue'

import {fb} from '../main'

Vue.config.silent = true
Vue.use(VueRouter)

const routes = [
  {
    path: '/registracija',
    name: 'Registration',
    component: Registration,
    meta: { 
      title:'Dobrodošli',
    }
  },
  {
    path: '/info',
    name: 'Info',
    component: Info,
    meta: { 
      requiresAuth:true,
      title:'Vaši podaci',
    }
  },  
  {
    path: '/informacije',
    name: 'Info-Stored',
    component: InfoStored,
    meta: { 
      requiresAuth:true,
      title:'Vaši podaci',
    }
  },  
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      title:'BilsteinGroup® club',
    }
  },
  {
    path: '/bodovi',
    name: 'Results',
    component: Results,
    meta: { 
      requiresAuth:true,
      title:'Vaši bodovi',
    }
  },
  {
    path: '/istorija',
    name: 'History',
    component: History,
    meta: { 
      requiresAuth:true,
      title:'Vaša istorija'
    }
  },
  {
    path: '/dobavljaci',
    name: 'Stores',
    component: Stores,
    meta: { 
      requiresAuth:true,
      title:'Izaberite svoje dobavljače'
    }
  },
  {
    path: '/poklon',
    name: 'Gift',
    component: Gift,
    meta: { 
      requiresAuth:true,
      title:'Čestitamo'
    }
  },
    {
    path: '/uslovi',
    name: 'Terms',
    component: Terms,
    meta: { 
      title:'Uslovi korišćenja'
    }
  },
]

const router = new VueRouter({routes, mode: 'history'})

export default router

router.beforeEach((to, from, next) => {
    const user = fb.auth().currentUser
    const requiresAuth = to.matched.some(record  => record.meta.requiresAuth)
    next()
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    if (requiresAuth && !user) {
        next('/')
    } else if (requiresAuth && user) {
        next()
    } else {
        next()
    }
})
